module.exports = __webpack_public_path__ + "img/ic_info.fea2b406.svg";